module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("\n        ☰\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto profile"
  }, [_c('dropdown', {
    staticClass: "nav-item",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    slot: "button"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": _vm.Auth.user.profile.photo_small,
      "alt": _vm.Auth.user.profile.email
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.Auth.user.profile.first_name) + " " + _vm._s(_vm.Auth.user.profile.last_name))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    slot: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('auth.account')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": '/account/profile'
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n                            " + _vm._s(_vm.$t('auth.profile')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" " + _vm._s(_vm.$t('auth.logout')))])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1350b147"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 515
// module chunks = 0